export default __webpack_public_path__ + "static/media/ken.a1ac27fb.png";